module.exports = __webpack_public_path__ + "img/img-8d8cb7.png";